// Copyright (c) 2016 Deere & Company

import * as partReturnActions from '../../actions-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import {updateList} from '../../../shared/services/list-selections';

const actions = {
    ...partReturnActions,
    ...userActions
};

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.defaultDealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.defaultDealerAccounts
            }
        },
        requestDateFacet: {
            $merge: {
                dateRange: {
                    from: null,
                    to: null
                }
            }
        },
        requestTypes: {
            allowedTypes: {
                $set: action.allowedRequestTypes
            },
            selectedTypes: {
                $set: action.allowedRequestTypes
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                selectedDealers: action.allowedDealers
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateAllowedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            allowedTypes: {
                $set: action.allowedTypes
            }
        }
    });

const updateIsInitialLoad = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: false
            }
        }
    });

const updateOpenPartRequestsDateRangeFacet = (state, action) =>
    Facets.update(state, {
        requestDateFacet: {
            dateRange: {
                $set: action.dateRange
            }
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateSelectedPartRequestType = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: updateList(
                    action.requestType,
                    action.isSelected,
                    'key',
                    state.requestTypes.selectedTypes
                )
            }
        }
    });

const updateSelectedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: action.requestTypes
            }
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_OPEN_PART_REQUESTS_FILTERS]: resetAllFacets,
        [actions.SELECT_ALL_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems,
        [actions.TOGGLE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.UPDATE_OPEN_PART_REQUESTS_ALLOWED_REQUEST_TYPES]: updateAllowedPartRequestTypes,
        [actions.UPDATE_OPEN_PART_REQUESTS_IS_INITIAL_LOAD]: updateIsInitialLoad,
        [actions.UPDATE_OPEN_PART_REQUESTS_REQUEST_DATE_RANGE_FACET]: updateOpenPartRequestsDateRangeFacet,
        [actions.UPDATE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_OPEN_PART_REQUESTS_SELECTED_REQUEST_TYPE]: updateSelectedPartRequestType,
        [actions.UPDATE_OPEN_PART_REQUESTS_SELECTED_REQUEST_TYPES]: updateSelectedPartRequestTypes,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/reducers/facets.js